module.exports = __webpack_public_path__ + "static/img/20.7260eb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/GoodsShow/AirPods Pro/imgs/second/20.jpg
// module id = i+lI
// module chunks = 0